import { render, staticRenderFns } from "./CreateSubject.vue?vue&type=template&id=07ca3cb8&scoped=true&lang=true&"
import script from "./CreateSubject.vue?vue&type=script&lang=js&"
export * from "./CreateSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ca3cb8",
  null
  
)

export default component.exports